import {
  GET_MEAL_PRICES_V3_RESPONSE,
  GET_MEAL_PRICE_V3_RESPONSE,
  CLEAR_MEAL_PRICES_V3,
} from 'lib/constants/v3Actions';

const initialState = {};

const transformFormMealPrices = mealPrices => {
  return mealPrices.reduce((acc, mealPrice) => {
    acc[mealPrice.id] = { name: mealPrice.name, priceCents: mealPrice.priceCents };
    return acc;
  }, {});
};

const clearMealPricesState = (state, menuSlug) => {
  return {
    ...state,
    [menuSlug]: initialState,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MEAL_PRICES_V3_RESPONSE:
      return {
        ...state,
        [action.params.menuSlug]: transformFormMealPrices(action.response.mealPrices),
      };
    case GET_MEAL_PRICE_V3_RESPONSE:
      return {
        ...state,
        [action.params.menuSlug]: transformFormMealPrices([action.response.mealPrice]),
      };
    case CLEAR_MEAL_PRICES_V3:
      return clearMealPricesState(state, action.menuSlug);
    default:
      return state;
  }
};

export const selectMealPrices = (state, menuSlug) => {
  return state[menuSlug] || {};
};
export const selectMealPrice = (state, menuSlug, mealId) =>
  selectMealPrices(state, menuSlug)[mealId];
